import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserView, MobileView } from 'react-device-detect';

import Loader from './components/@jobit/Loader/Loader';
import * as serviceWorker from './serviceWorker';

const App = React.lazy(() => import('./App'));
const Mobile = React.lazy(() => import('./pages/Mobile/Mobile'));

const app = (
  <>
    <BrowserView>
      <Suspense fallback={<Loader />}>
        <App />
      </Suspense>
    </BrowserView>
    <MobileView>
      <Suspense fallback={null}>
        <Mobile />
      </Suspense>
    </MobileView>
  </>
);

ReactDOM.render(app, document.getElementById('root'));
serviceWorker.unregister();
